import { createSlice } from '@reduxjs/toolkit';

type LanguageState = string;

const initialState: LanguageState = 'zh';

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    resetSlice: () => initialState,
  },
});

export default languageSlice.reducer;
